import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

export const IMAGE_STEPS = ['load', 'straighten', 'correct', 'download'] as const;
export type ImageStep = (typeof IMAGE_STEPS)[number];

/** The four steps of the Immagini tool; on a phone only the numbers show (#387 boards). */
export function Stepper({ active }: { readonly active: ImageStep }) {
  const { t } = useTranslation('tools');
  const activeIndex = IMAGE_STEPS.indexOf(active);
  return (
    <ol aria-label={t('images.steps.label')} className="flex flex-wrap items-center gap-2.5">
      {IMAGE_STEPS.map((step, i) => {
        const on = i === activeIndex;
        const done = i < activeIndex;
        return (
          <li key={step} aria-current={on ? 'step' : undefined} className="flex items-center gap-2">
            {i > 0 && <span aria-hidden="true" className="h-px w-5 bg-border sm:w-7" />}
            <span
              aria-hidden="true"
              className={cn(
                'flex size-6 items-center justify-center rounded-full text-xs font-semibold',
                on && 'bg-primary text-primary-foreground',
                done && 'bg-accent text-accent-foreground',
                !on && !done && 'bg-muted text-muted-foreground',
              )}
            >
              {done ? <Check className="size-3.5" /> : i + 1}
            </span>
            <span
              className={cn(
                'text-sm',
                on
                  ? 'font-semibold text-foreground'
                  : 'sr-only text-muted-foreground sm:not-sr-only',
              )}
            >
              {t(`images.steps.${step}`)}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
